import { log } from 'log';
import { useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import * as Types from '../types';
import * as constants from '../constants';
import { validateGeolocation } from 'js/hooks/auth/pas';

export const useOnConnect = ({
    setShowOverlay,
    runBrowserGeolocation,
    triggerGeolocation,
    geolocationType,
    skipBrowserGeolocation = false
}: {
    setShowOverlay: (showOverlay: boolean) => void;
    runBrowserGeolocation: () => Promise<GeolocationPosition>;
    triggerGeolocation: Types.TriggerGeolocationCallback;
    geolocationType: string;
    skipBrowserGeolocation: boolean;
}) => {
    return useCallback(async () => {
        log('gcInfo', { event: 'connected' });

        if (skipBrowserGeolocation) {
            await triggerGeolocation({
                reason: constants.GEOLOCATION_REASON.INITIAL_CHECK
            });

            return;
        }

        try {
            const coordinates = await runBrowserGeolocation();
            const { latitude, longitude } = coordinates?.coords ?? {};

            await triggerGeolocation({
                reason: constants.GEOLOCATION_REASON.INITIAL_CHECK,
                latitude,
                longitude
            });
        } catch (error: any) {
            publicEventsAPIService.trigger('geofencing-error', { error });

            log('gcErr', { error });

            try {
                // report issue back to IMS so that it is visible in the event log
                const response = await validateGeolocation(null, null, null, null, null, geolocationType);
                const sessionValidationData = response.data.sessionValidationData || {};
                const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
                const geolocationData = sessionValidationByGeolocationData[0] || {};

                await validateGeolocation(
                    null,
                    null,
                    null,
                    geolocationData.transactionId,
                    String(error?.message),
                    geolocationType
                );
            } catch (validationError) {
                // noop
                // since this is expected that validateGeolocation will throw an error
            } finally {
                // noop
            }

            if (error?.code === window.GeolocationPositionError?.PERMISSION_DENIED) {
                // player has not allowed geolocation
                setShowOverlay(false);
                return;
            }

            await triggerGeolocation({
                reason: constants.GEOLOCATION_REASON.INITIAL_CHECK
            });
        }
    }, [
        setShowOverlay,
        triggerGeolocation,
        runBrowserGeolocation,
        geolocationType,
        skipBrowserGeolocation
    ]);
};
